/*
 *
 * ProfilePage constants
 *
 */
export var CHANGE_PASSWORD_REQUEST = 'src/ProfilePage/CHANGE_PASSWORD_REQUEST';
export var CHANGE_PASSWORD_SUCCESS = 'src/ProfilePage/CHANGE_PASSWORD_SUCCESS';
export var CHANGE_PASSWORD_FAILURE = 'src/ProfilePage/CHANGE_PASSWORD_FAILURE';
export var TWO_FA_REQUEST = 'src/ProfilePage/TWO_FA_REQUEST';
export var TWO_FA_SUCCESS = 'src/ProfilePage/TWO_FA_SUCCESS';
export var TWO_FA_FAILURE = 'src/ProfilePage/TWO_FA_FAILURE';
export var ENABLE_TWO_FA_REQUEST = 'src/ProfilePage/ENABLE_TWO_FA_REQUEST';
export var ENABLE_TWO_FA_SUCCESS = 'src/ProfilePage/ENABLE_TWO_FA_SUCCESS';
export var ENABLE_TWO_FA_FAILURE = 'src/ProfilePage/ENABLE_TWO_FA_FAILURE';
export var DISABLE_TWO_FA_REQUEST = 'src/ProfilePage/DISABLE_TWO_FA_REQUEST';
export var DISABLE_TWO_FA_SUCCESS = 'src/ProfilePage/DISABLE_TWO_FA_SUCCESS';
export var DISABLE_TWO_FA_FAILURE = 'src/ProfilePage/DISABLE_TWO_FA_FAILURE';
export var UPDATE_PROFILE_NAME_REQUEST = 'src/ProfilePage/UPDATE_PROFILE_NAME_REQUEST';
export var UPDATE_PROFILE_NAME_SUCCESS = 'src/ProfilePage/UPDATE_PROFILE_NAME_SUCCESS';
export var UPDATE_PROFILE_NAME_FAILURE = 'src/ProfilePage/UPDATE_PROFILE_NAME_FAILURE';
export var UPDATE_PROFILE_PICTURE_REQUEST = 'src/ProfilePage/UPDATE_PROFILE_PICTURE_REQUEST';
export var UPDATE_PROFILE_PICTURE_SUCCESS = 'src/ProfilePage/UPDATE_PROFILE_PICTURE_SUCCESS';
export var UPDATE_PROFILE_PICTURE_FAILURE = 'src/ProfilePage/UPDATE_PROFILE_PICTURE_FAILURE';
export var PROFILE_DELETE_REQUEST = 'src/ProfilePage/PROFILE_DELETE_REQUEST';
export var PROFILE_DELETE_SUCCESS = 'src/ProfilePage/PROFILE_DELETE_SUCCESS';
export var PROFILE_DELETE_FAILURE = 'src/ProfilePage/PROFILE_DELETE_FAILURE';
